import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { UserService } from './user.service';
import { Observable, of, switchMap } from 'rxjs';

/**
 * Angular guard to protect routes and trigger login flow
 * To use guard, module authOnAppInitializer option need to be false.
 *
 * Add this Guard on your module routing file to secure screens with CanActivate and CanActivateChild
 */
@Injectable()
export class CustomAuthGuard {
  constructor(readonly router: Router, private readonly platformLocation: PlatformLocation, private readonly userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.userService.checkUserRights().pipe(
        switchMap((allowed: boolean) => {
            if(allowed){
                return of(allowed);
            };
            sessionStorage.clear();
            sessionStorage.setItem('unauthorized', 'unauthorized');
            this.router.navigate(['/loggedout']);
            return of(false);
        })
    );    
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<any> {
    return this.canActivate(route, state);
  }
}
